module.exports = __webpack_public_path__ + "static/media/img-3.05fc7c62.jpg";